import { Module } from 'vuex';
import moment from 'moment';
import { Priority } from '@/types/Logbuch';
import { LogbuchState, RootState } from '@/store/types';

export const logbuch: Module<LogbuchState, RootState> = {
    namespaced: true,
    state: {
        filter: {
            zeitraum: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            loglevel: Priority.Info,
            patnr: null,
            aktion: null,
            function: null,
            user_id: null
        },
    },
};
